<div class="mydocma-dialog-container">

  <div class="mydocma-dialog-header" *ngIf="!this.mediaQueryService?.isXs; else mobileHeader">
    <div class="mydomca-dialog-header-title">
      {{title$ | async}}
    </div>
    <div>
      <button mat-icon-button type= "button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>

    </div>
  </div>

  <div class="mydocma-dialog-body">
    <mydocma-loader [size]="'small'" class="mydocma-mm-loader" *ngIf="(loading$ | async) || (saving$ | async)"></mydocma-loader>
    <div class="ld-dialog-content" mydocmaResizeEvent (resize)="onResize($event)">

      <div class="ld-form-content" *ngIf="formConfig">
        <mydocma-dynamic-form [formConfig]="formConfig" (ready)="onFormReady($event)">
        </mydocma-dynamic-form>
      </div>
    </div>

  </div>

  <div class="mydocma-dialog-footer" *ngIf="!this.mediaQueryService?.isXs">
      <div style="margin-right: 10px">
        <button mat-stroked-button class="mydocma-btn"
                (click)="onCancel()">
          {{'MM.general.button.cancel' | translate}}
        </button>
      </div>
      <div>
        <button mat-stroked-button class="mydocma-btn-primary"
                (click)="onSaveChanges()" [disabled]="(loading$ | async) || (saving$ | async)">
          {{'MM.general.button.ok' | translate}}
        </button>
      </div>
  </div>

  <ng-template #mobileHeader>
    <div *ngIf="this.mediaQueryService?.isXs" class="mydocma-dialog-header">

      <div class="mm-pane-header mydocma-detail-header" fxFlex="row" fxFlexAlign="center space-between" style="flex: 1 1 100%">
        <button mat-stroked-button type="button" class="mydocma-btn-primary" [disabled]="(loading$ | async) || (saving$ | async)" (click)="onSaveChanges()">
          {{'MM.general.button.ok' | translate }}
        </button>

        <div class="mm-pane-header-title"
             style="display: block">
          <div class="mm-pane-header-text">{{title$ | async}}</div>
        </div>
        <button
          style="display: block"
          mat-icon-button type="button" (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

    </div>
  </ng-template>
</div>
